<script>
export default {
  name: "NotificationZone",
  props: {
    notifications: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div
    id="sr-notification"
    ref="notificationZone"
    aria-live="polite"
    class="u-sr-only"
  >
    <p
      v-for="(notif, i) in notifications"
      :key="i"
    >
      {{ notif }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
</style>
